// hk-insert-btn.js — insert Add-to-Cart next to price if price element exists
(function(){
  function findVariantId(card){
    // try find an input with name="id" inside card (common)
    var inp = card.querySelector('input[name="id"]');
    if(inp && inp.value) return inp.value;
    // try data attributes
    if(card.dataset && card.dataset.variantId) return card.dataset.variantId;
    if(card.getAttribute('data-variant-id')) return card.getAttribute('data-variant-id');
    // no variant found
    return null;
  }

  function createAddButton(variantId, productUrl){
    if(variantId){
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.style.display = 'inline-block';
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = variantId;
      form.appendChild(input);

      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.className = 'hk-btn hk-js-add';
      btn.textContent = 'Add to Cart';
      form.appendChild(btn);
      return form;
    } else {
      // fallback: link to product page if variant id not found
      var a = document.createElement('a');
      a.href = productUrl || '#';
      a.className = 'hk-btn hk-js-add';
      a.textContent = 'View / Add';
      return a;
    }
  }

  function insertButtons(){
    var cardSelectors = [
      '.product-card', '.product-grid-item', '.card', '.grid__item', '.product-item'
    ];
    var priceSelectors = [
      '.price', '.product-price', '.price-item--regular', '.price__regular', '[data-product-price]', '.money'
    ];
    var cards = document.querySelectorAll(cardSelectors.join(','));
    cards.forEach(function(card){
      try{
        // avoid duplicate
        if(card.querySelector('.hk-js-add')) return;

        // find price element inside card
        var priceEl = null;
        for(var i=0;i<priceSelectors.length;i++){
          priceEl = card.querySelector(priceSelectors[i]);
          if(priceEl) break;
        }

        // fallback: try to find any element that contains currency symbol
        if(!priceEl){
          var possible = card.querySelectorAll('span,div');
          for(var j=0;j<possible.length;j++){
            if(possible[j].textContent && possible[j].textContent.trim().match(/₹|\$|£|€/)){
              priceEl = possible[j];
              break;
            }
          }
        }

        var variantId = findVariantId(card);
        // try product url from card links
        var link = card.querySelector('a[href*="/products/"]');
        var productUrl = link ? link.href : null;

        var addNode = createAddButton(variantId, productUrl);

        if(priceEl && priceEl.parentNode){
          // create wrapper for inline placement
          var wrapper = document.createElement('span');
          wrapper.className = 'hk-inline-wrapper';
          // insert wrapper after priceEl
          priceEl.parentNode.insertBefore(wrapper, priceEl.nextSibling);
          wrapper.appendChild(addNode);
        } else if (productUrl){
          // if no price found, append at end of card
          card.appendChild(addNode);
        }
      }catch(e){ console.error('hk insert err', e); }
    });
  }

  // init on DOM ready and also after small delay (for lazy-render themes)
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(insertButtons, 800);
    // also run after 2s and on ajax events
    setTimeout(insertButtons, 2000);
  });

  // observe DOM changes (for infinite scroll or lazy load)
  var observer = new MutationObserver(function(){ insertButtons(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();